// 部门管理
export default {
    departmentalInquiry: 'Ведомственное расследование',
    personInChargeInquiry: 'Ответственный запрос',
    mobileNumberQuery: 'Запрос мобильного номера',
    department: 'отделение',
    numberOfPeople: 'число людей',
    principal: 'главный',
    contactInformation: 'Контакты',
    countryOrRegion: 'страна / регион',
    provinceCity: 'Провинция/город',
    personnelManagement: 'Кадровый менеджмент',
    addDepartment: 'Добавить отдел',
    editDepartment: 'Редакционный отдел',
    departmentName: 'Название отдела',
    location: 'место нахождения',
    userAccount: 'учетная запись пользователя',
    role: 'Роль',
    licenseType: 'Тип лицензии',
    departmentDescription: 'Описание отдела',
    pleaseEnterContent: 'Пожалуйста, введите содержание',
    nameQuery: 'запрос имени',
    license: 'лицензия',
    totalStaff: 'Всего сотрудников',
    personsName: 'Имя человека',
    telephone: 'телефон',
    operate: 'действовать',
    enterDepartmentName: 'Пожалуйста, введите название отдела',
    PleaseSelectLocation: 'Пожалуйста, выберите местоположение',
    enterPerson: 'Пожалуйста, укажите ответственное лицо',
    peopleSearch: 'поиск людей',
    userExistsTip:"Пользователь уже существует, пожалуйста, не добавляйте его снова",
    addFailedTip:"Добавить не удалось, пользователь уже находится в другом отделе",
    selectAddper:'Выберите человека, которого хотите добавить',
    delTip:'Уведомление! После удаления отдела информация о персонале отдела будет сохранена, а данные отдела будут удалены, действуйте с осторожностью.',
    delDep:'удалить отдел'
}
